import React from 'react';
import styled from 'styled-components';
import defaultAuthImage from '../assets/home-page-background.jpg'; // Renamed import for clarity

interface AuthLayoutProps {
  children: React.ReactNode;
  imageUrl?: string;
  altText?: string;
}

const Container = styled.div`
  display: flex;
  min-height: 100vh;
  width: 100vw;
  background-color: #ededed;
`;

const AuthContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh; /* Fixed height */
  overflow: hidden; /* Prevent AuthContainer itself from scrolling */
`;

// Updated FormSection: flex container, allows scrolling
const FormSection = styled.div`
  flex: 1;
  display: flex; /* Use flexbox to manage children */
  flex-direction: column; /* Stack children vertically */
  align-items: center; /* Center children horizontally */
  background-color: #f7f7f7;
  padding: 20px; /* Padding around the scrollable area */
  overflow-y: auto; /* Enable vertical scrolling ONLY when needed */
  max-height: 100vh; /* Ensure it doesn't exceed viewport height */
`;

// Updated FormWrapper: Centers itself vertically using margin: auto
const FormWrapper = styled.div`
  width: 100%;
  max-width: 450px;
  padding: 20px; /* Inner padding for the content */
  margin: auto 0; /* Key change: Centers vertically when content is smaller than FormSection */
`;

const ImageSection = styled.div`
  flex: 1;
  height: 100%;
  display: none;
  
  /* Only show on desktop */
  @media (min-width: 992px) {
    display: block;
  }
`;

const AuthImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

const AuthLayout: React.FC<AuthLayoutProps> = ({ 
  children, 
  imageUrl,
  altText = 'Authentication image'
}) => {
  // Use provided imageUrl or fall back to default
  const imageSrc = defaultAuthImage;

  return (
    <Container>
      <AuthContainer>
        <FormSection>
          <FormWrapper>
            {children}
          </FormWrapper>
        </FormSection>
        <ImageSection>
          <AuthImage src={imageSrc} alt={altText} />
        </ImageSection>
      </AuthContainer>
    </Container>
  );
};

export default AuthLayout;